import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Form, Button, InputGroup, Card, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCreditCard, faEnvelope, faUser, faPhone, faHome, faMoneyBillWave } from '@fortawesome/free-solid-svg-icons';
import './DonationForm.css'; // Assuming you have a CSS file for custom styles
import { BraintreeService, CampaignService, DonationService, SubscriptionService } from '../../Services/Axios/Api';
import { useParams } from 'react-router-dom';
import CTAPrimaryButton from '../../Components/CTAButton/CTAPrimaryButton/CTAPrimaryButton';
import { getAllowedMethods, getCurrency } from '../../ComponentsMap';
import { t } from 'i18next';
import i18n from '../../Services/i18n/i18n';
import BraintreeDropIn from '../../Components/Braintree/BraintreeDropIn';
const SanadDonationForm = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        amount: '10',
        customAmount: '',
        message: '',
        paymentMethod: getAllowedMethods()[0],
        isAnonymous: false
    });
    const { id } = useParams();
    const [campaignData, setCampaignData] = useState(null);
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [braintreeData, setBraintreeData] = useState(null);
    const [braintreeInstance, setBraintreeInstance] = useState(null);
    useEffect(() => {
        const fetchCampaignData = async () => {
            try {
                const response = await CampaignService.getCampaignById(id);
                setCampaignData(response.result);
            } catch (error) {
                console.error('Error fetching campaign data:', error);
            }
        };
        const fetchClientToken = async () => {
            try {
                const response = await BraintreeService.getClientToken();
                setBraintreeData(response);
            } catch (error) {
                console.error('Error fetching client token:', error);
            }
        }
        fetchCampaignData();
        fetchClientToken();
    }, [id]);


    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    const validateForm = () => {
        const errors = {};
        if (!formData.firstName.trim()) errors.firstName = t('DonationForm.Validation.FirstNameRequired');
        if (!formData.lastName.trim()) errors.lastName = t('DonationForm.Validation.LastNameRequired');
        if (!formData.email.trim()) errors.email = t('DonationForm.Validation.EmailRequired');
        if (!formData.phoneNumber.trim()) errors.phoneNumber = t('DonationForm.Validation.PhoneNumberRequired');
        if(!campaignData?.isRecurring){
            if (formData.amount === 'custom' && (!formData.customAmount || formData.customAmount < 10)) {
                errors.customAmount = t('DonationForm.Validation.CustomAmountRequired');
            }
        }
        
       
        
        
        return errors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = validateForm();
        if (Object.keys(errors).length > 0) {
            console.error('Validation errors:', errors);
            setErrors(errors);
            return;
        }
        setIsLoading(true);
        var paymentNonce = null;
        try {
            // Get payment nonce if using Braintree
            if (formData.paymentMethod === 'PayPal' && braintreeInstance) {
                try {
                    const { nonce } = await braintreeInstance.requestPaymentMethod();
                    console.log("nonce", nonce);
                     // Add validation for Braintree payment method
                    if (!nonce) {
                        setErrors({ paymentMethod: t('DonationForm.Validation.PaymentMethodRequired') });
                        setIsLoading(false);
                        return;
                    }
                    setErrors({ paymentMethod: '' });
                    paymentNonce = nonce;
                } catch (error) {
                    console.error('Error getting payment nonce:', error);
                    setErrors({ paymentMethod: t('DonationForm.Validation.PaymentMethodRequired') });
                    setIsLoading(false);
                    return;
                }
            }

            if(!campaignData?.isRecurring){
                const data = { 
                    donorInfo: {
                        "name": formData.firstName + " " + formData.lastName,
                        "email": formData.email,
                        "phoneNumber": formData.phoneNumber,

                        "city": "string",
                        "country": "string",
                        "postalCode": "string",
                        "isAnonymous": formData.isAnonymous
                    },
                    "campaignId": id,
                    "amount": formData.amount,
                    "currency": getCurrency().Appriviation,
                    "paymentMethod": formData.paymentMethod,
                    "message": formData.message,
                    "isAnonymous": formData.isAnonymous,
                    "nonce": paymentNonce,
                    "transactionId": braintreeData?.transactionId
                }
                console.log("data", data);
                const response = await DonationService.createDonation(data);
                // window.location.href = response.result;
                console.log(response);
            } else {
                const data = {  
                    "donor": {
                        "name": formData.firstName + " " + formData.lastName,
                        "email": formData.email,
                        "phoneNumber": formData.phoneNumber,

                        "city": "string",
                        "country": "string",
                        "postalCode": "string",
                        "isAnonymous": formData.isAnonymous
                    },
                    "campaignId": id,
                    "paymentMethod": formData.paymentMethod,
                    "nonce": paymentNonce,
                    "transactionId": braintreeData?.transactionId
                }   
                console.log(data);
                const response = await SubscriptionService.createSubscription(data);
                // window.location.href = response.result.invoices[0].paymentUrl;
                console.log(response);
            }
        } catch (error) {
            console.error('Error creating donation:', error);
            setIsLoading(false);
        } finally {
            setIsLoading(false);
        }
    };

    const handleBraintreeInstanceReady = (instance) => {
        setBraintreeInstance(instance);
    };

    return (
        <Container className="mt-5 mb-5 d-flex justify-content-center">
            <Col md={10}>
                <Card className="p-4 position-relative">
                    {isLoading && (
                        <div
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                zIndex: 100,
                                borderRadius: '0.375rem'
                            }}
                        >
                            <div className="text-center">
                                <Spinner animation="border" role="status" variant="primary">
                                    <span className="visually-hidden">Loading...</span>
                                </Spinner>
                                <p className="mt-2">Processing your donation...</p>
                            </div>
                        </div>
                    )}
                    {campaignData && (
                        <div
                            className="campaign-header"
                            style={{
                                backgroundImage: `url(${campaignData.mainImage})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                color: 'white',
                                padding: '20px',
                                width: '100%',
                                height: '200px',
                                borderRadius: '5px 5px 0 0'
                            }}

                        >
                            <h2 className="mb-2">{campaignData.name || 'Donation Form'}</h2>
                            <p>{campaignData.description || 'No description available'}</p>
                        </div>
                    )}
                    <Card.Body>
                        <Form onSubmit={handleSubmit}>
                            <Form.Group controlId="amount" className="mb-4">
                                {!campaignData?.isRecurring && (
                                    <>
                                    <Form.Label>{t('DonationForm.DonationAmount')}</Form.Label>
                                <div className="d-flex flex-wrap justify-content-between">
                                    {['10', '25', '50', '100', '250'].map((value) => (
                                        <CTAPrimaryButton
                                            key={value}
                                            className={`amount-card ${formData.amount === value ? 'filled' : 'outlined'}`}
                                            onClick={(e) => { e.preventDefault(); setFormData({ ...formData, amount: value, customAmount: '' }); }}
                                            text={`${getCurrency().Symbol} ${value}`}
                                        />
                                    ))}
                                    <CTAPrimaryButton
                                        className={`amount-card ${formData.amount === 'custom' ? 'filled' : 'outlined'}`}
                                        onClick={(e) => { e.preventDefault(); setFormData({ ...formData, amount: 'custom' }); }}
                                        text={t('DonationForm.CustomAmount')}
                                    />
                                </div>
                                {formData.amount === 'custom' && (
                                    <Form.Control
                                        type="number"
                                        placeholder={t('DonationForm.EnterCustomAmount')}
                                        name="customAmount"
                                        value={formData.customAmount}
                                        onChange={handleChange}
                                        min="10"
                                        className="mt-3"
                                        isInvalid={!!errors.customAmount}
                                    />
                                )}
                                </>
                                )}
                                
                                
                            </Form.Group>
                            <Row className="mb-3">
                                <Col md={6}>
                                    <Form.Group controlId="firstName">
                                        <Form.Label>{t('DonationForm.FirstName')}</Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text><FontAwesomeIcon icon={faUser} /></InputGroup.Text>
                                            <Form.Control
                                                type="text"
                                                placeholder={t('DonationForm.EnterYourFirstName')}
                                                name="firstName"
                                                value={formData.firstName}
                                                onChange={handleChange}
                                                required
                                                isInvalid={!!errors.firstName}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.firstName}
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group controlId="lastName">
                                        <Form.Label>{t('DonationForm.LastName')}</Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text><FontAwesomeIcon icon={faUser} /></InputGroup.Text>
                                            <Form.Control
                                                type="text"
                                                placeholder={t('DonationForm.EnterYourLastName')}
                                                name="lastName"
                                                value={formData.lastName}
                                                onChange={handleChange}
                                                required
                                                isInvalid={!!errors.lastName}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.lastName}
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col md={6}>
                                    <Form.Group controlId="email">
                                        <Form.Label>{t('DonationForm.Email')}</Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text><FontAwesomeIcon icon={faEnvelope} /></InputGroup.Text>
                                            <Form.Control
                                                type="email"
                                                placeholder={t('DonationForm.EnterYourEmail')}
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                                isInvalid={!!errors.email}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.email}
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group controlId="phoneNumber">
                                        <Form.Label>{t('DonationForm.PhoneNumber')}</Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text><FontAwesomeIcon icon={faPhone} /></InputGroup.Text>
                                            <Form.Control
                                                dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                                                type="tel"
                                                placeholder={t('DonationForm.EnterYourPhoneNumber')}
                                                name="phoneNumber"
                                                value={formData.phoneNumber}
                                                onChange={handleChange}
                                                required
                                                isInvalid={!!errors.phoneNumber}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.phoneNumber}
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Form.Group controlId="message" className="mb-3">
                                <Form.Label>{t('DonationForm.Message')}</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    placeholder={t('DonationForm.EnterYourMessage')}
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                            
                            {braintreeData && (
                                <BraintreeDropIn 
                                    clientToken={braintreeData.clientToken} 
                                    amount={formData.amount} 
                                    onInstanceReady={handleBraintreeInstanceReady}
                                />
                            )}
                            {errors.paymentMethod && (
                                <div className="text-danger mt-0 mb-3">
                                    <span>{errors.paymentMethod}</span>
                                </div>
                            )}
                            
                            <div className="d-flex justify-content-center">
                                <CTAPrimaryButton
                                    text={t('DonateNow')}
                                    onClick={(e) => handleSubmit(e)}
                                />
                            </div>
                            
                        </Form>
                    </Card.Body>
                </Card>
            </Col>
        </Container>
    );
};

export default SanadDonationForm;